<script>
  import { Progressbar } from "framework7-svelte";

  export let user = {};
  export let agreementSigned = false;

  let percent = 0;
  let totalSteps = 18;
  let completedCount = 0;

  $: {
    calculateProgress(user, agreementSigned);
  }

  function calculateProgress(u, isSigned) {
    if (!u) {
      percent = 0;
      totalSteps = 18;
      completedCount = 0;
      return;
    }

    // If account is already approved, it's 100% complete
    if (u.account_status && u.account_status.toLowerCase() === "approved") {
      percent = 100;
      totalSteps = 18;
      completedCount = 18;
      return;
    }

    const steps = u.workflow_steps || (u.workflow && u.workflow.workflow_steps);

    if (Array.isArray(steps) && steps.length > 0) {
      totalSteps = steps.length;
      completedCount = steps.filter(
        (s) => s.status === "completed" || s.status === "verified" || s.status === "done"
      ).length;

      // If completed count is 0 but current step is specified, estimate progress by step index
      if (completedCount === 0 && (u.current_workflow_step_id || u.current_step_name)) {
        const curIdx = steps.findIndex(
          (s) => (s._id && s._id.toString() === String(u.current_workflow_step_id)) || s.name === u.current_step_name
        );
        if (curIdx !== -1) {
          completedCount = curIdx + 1;
        }
      }

      // If KYC agreement is signed, ensure at least agreement step is reflected
      if (isSigned && completedCount < totalSteps - 2) {
        completedCount = Math.max(completedCount, totalSteps - 2);
      }

      percent = Math.min(100, Math.round((completedCount / totalSteps) * 100));
    } else if (isSigned) {
      totalSteps = 18;
      completedCount = 16;
      percent = 90;
    } else {
      totalSteps = 18;
      completedCount = 0;
      percent = 0;
    }
  }
</script>

<div class="signup-progress-container">
  <div class="progress-header">
    <span class="progress-title">Signup progress</span>
    <span class="progress-percent-badge {percent === 100 ? 'complete' : ''}">
      {percent}%
    </span>
  </div>

  <div class="progress-bar-wrapper">
    <Progressbar
      progress={percent}
      color={percent === 100 ? "green" : percent > 50 ? "blue" : "orange"}
      style="height: 6px; border-radius: 4px;"
    />
  </div>

  <div class="step-summary-text">
    {completedCount} of {totalSteps} steps completed
  </div>
</div>

<style>
  .signup-progress-container {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px dashed #e2e8f0;
  }
  .progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }
  .progress-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
  }
  .progress-percent-badge {
    font-size: 11px;
    font-weight: 700;
    color: #0284c7;
    background: #e0f2fe;
    padding: 2px 7px;
    border-radius: 12px;
  }
  .progress-percent-badge.complete {
    color: #15803d;
    background: #dcfce7;
  }
  .progress-bar-wrapper {
    margin-bottom: 5px;
  }
  .step-summary-text {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 500;
  }
</style>
